module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (!authUser) { ;
__p += '\n  <div class="btn-back"></div>\n  <div class="login-container">\n    ';
 if (level == LOGIN_LEVEL.EXPIRED) { ;
__p += '\n      <span class="help-block">\n        Oops! Your session has expired. Please log in again.\n      </span>\n    ';
 } else if (level == LOGIN_LEVEL.DEACTIVATED) { ;
__p += '\n      <span class="help-block">\n        This account has been deactivated. Please contact support for assistance.\n      </span>\n    ';
 } else if (level == LOGIN_LEVEL.SUSPENDED) { ;
__p += '\n      <span class="help-block">\n        This account has been deactivated for 30 days due to repeated no shows. Please contact support for assistance.\n      </span>\n    ';
 } else if (level == LOGIN_LEVEL.TIMEOUT) { ;
__p += '\n      <span class="help-block">\n        Your session has expired because of your company\'s configured session timeout. Please log in again.\n      </span>\n    ';
 } else if (level == LOGIN_LEVEL.PW_CHANGED) { ;
__p += '\n      <span class="help-block">\n        Your password has been changed.  Please log in again.\n      </span>\n    ';
 } ;
__p += '\n    ';
 if (handle) { ;
__p += '\n      <span class="help-block">\n        An account with this ' +
__e( handleDesc ) +
' already exists.\n      </span>\n      <span class="help-block">\n        Log in below to continue.\n      </span>\n    ';
 } ;
__p += '\n    ';
 if (level == LOGIN_LEVEL.RESET) { ;
__p += '\n      <h1>Forgot password?</h1>\n      <span class="subtitle">\n        Let\'s look up your account\n      </span>\n    ';
 } else { ;
__p += '\n      <h1>Log in</h1>\n    ';
 } ;
__p += '\n    <div class="handle-component"></div>\n  </div>\n  <div id="stack-container"></div>\n';
 } else { ;
__p += '\n  <div class="password-container"></div>\n';
 } ;
__p += '\n';

}
return __p
}